import { BaseProyectaService, IBaseProyectaService } from "./base-proyecta.service";
import { Enums, Dictionary, Utilities, String, Constants } from "../../utils/utilities";
import { IAEAColumnDefinition, IBudgetFormBasicDataMasters, IBudgetSummary, IBudgetCsvByCountry, IBudgetCsvByOn, ICmdBasicDataProjectBudget, IBasicDataProjectBudgetDTO, ICmdTableBudgetByProject, ICmdTableBudgetFFCC, ICmdTableBudgetFFRR } from '@models/'

export interface IBudgetService extends IBaseProyectaService {
    getBudgetBasicDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getBudgetDetailColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getAllFormMasters(langLabel: string): Promise<IBudgetFormBasicDataMasters>;
    getAllBudgetSummary(langLabel: string): Promise<IBudgetSummary[]>;
    getAllBudgetByCountry(langLabel: string): Promise<IBudgetCsvByCountry[]>;
    getAllBudgetByOn(langLabel: string): Promise<IBudgetCsvByOn[]>;
    getAllBudgetAndDetails(): Promise<any[]>;
    getProjectNumber(title?: string): Promise<string>;
    getBasicBudgets(filter: boolean): Promise<any>;
    getBudgetAndDetails(budgetId: number): Promise<any>;
    getExpandBudgets(): Promise<any[]>;
    getProjectCodeId(projectCode: string, basicData: ICmdBasicDataProjectBudget): Promise<any>;

    saveBudget(_budget: any, projectExist: boolean, tableBudgetByProject: Array<ICmdTableBudgetByProject>, tablebudgetFFCC: Array<ICmdTableBudgetFFCC>, tableFFRR: Array<ICmdTableBudgetFFRR>, PPresTipoPresId: number, currentUserEmail: string): Promise<any>;
    updateBudget(_budget: any, tableBudgetByProject: Array<ICmdTableBudgetByProject>, tablebudgetFFCC: Array<ICmdTableBudgetFFCC>, tableFFRR: Array<ICmdTableBudgetFFRR>, currentUserEmail: string): Promise<any>;
    getBudgetResumeDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getBudgetIndexDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getBudgetCSVDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getFormBudgetTablesColumnDefinition(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getFormBudgetTablesFFCCColumnDefinition(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getProjectByGrantCodeId(grantCodeId: number): Promise<any>;
}

export class BudgetService extends BaseProyectaService implements IBudgetService {
    private getDetailHeader(budgets: any[], details: any[]): any[] {
        let results: any[] = [];
        details.forEach(item => {
            if (!Utilities.isNullEmptyObject(item.PPresPresupuesto)) {
                const aux = budgets.filter(x => x.Id === item.PPresPresupuesto.Id);
                item["budget"] = aux !== null ? aux[0] : [];
                results.push(item);
            }

        })
        return results
    }
    private mappBudgetEntityToCurrentBudget(budgetEntity: IBasicDataProjectBudgetDTO) {
        const currentBudget: any = {
            PPresTipoPresId: budgetEntity.PPresTipoPresId,
            PPresCodProy: budgetEntity.CodigoProyectoId ? budgetEntity.CodigoProyecto.Title : null,
            PPresNumProy: budgetEntity.PPresNumProy,
            PPresPresupuestoId: budgetEntity.PPresPresupuestoId,
            Id: budgetEntity.Id,
            Year: [{ id: budgetEntity.PPresAnio.Id, label: budgetEntity.PPresAnio.Title }]
        }

        if (budgetEntity.PPresTipoPresId !== Enums.SystemParameters.BudgetTypeOn) {
            currentBudget.LineaIntervencionId = [{ id: budgetEntity.OCTAVIALineaIntervencion.Id, label: budgetEntity.OCTAVIALineaIntervencion.Title }];
            currentBudget.Title = budgetEntity.Title
        }
        if (!Utilities.isNullObject(budgetEntity.OCTAVIAPais)) {
            currentBudget.RegionCountry = [{ id: budgetEntity.OCTAVIAPais.Id, label: budgetEntity.OCTAVIAPais.Title, code: budgetEntity.OCTAVIAPais.OCTAVIACodigo }];
        } else {
            currentBudget.RegionCountry = [{ id: Constants.Globals.PREFFIX_RG + budgetEntity.OCTAVIARegion.Id, label: budgetEntity.OCTAVIARegion.Title, code: budgetEntity.OCTAVIARegion.OCTAVIACodigo }];
        }
        return currentBudget;
    }
    private mappBudgetDetailsToModels(details: any): any {
        //Table By project mapping
        let _byProjectAux = details.filter((x: any) => { if (!Utilities.isNullEmptyObject(x.PPresCodPep)) { return true; } });
        let tableByProject: Array<any> = _byProjectAux.map((x: any) => {
            let aux: any = {
                Id: x.Id,
                OCTAVIAFinanciadorSap: Utilities.isNullObject(x.OCTAVIAFinanciadorSap) ? x.OCTAVIAFinanciadorSap : { id: x.OCTAVIAFinanciadorSap.Id, label: x.OCTAVIAFinanciadorSap.Title },
                PPresCodSubvencion: Utilities.isNullObject(x.PPresCodSubvencion) ? x.PPresCodSubvencion : { id: x.PPresCodSubvencion.Id, label: x.PPresCodSubvencion.Title },
                PPresNatuGasto: Utilities.isNullObject(x.PPresNatuGasto) ? x.PPresNatuGasto : { id: x.PPresNatuGasto.Id, label: x.PPresNatuGasto.Title },
                ProaRecupCostes: Utilities.isNullObject(x.ProaRecupCostes) ? x.ProaRecupCostes : { id: x.ProaRecupCostes.Id, label: x.ProaRecupCostes.Title },
                PPresCodPep: x.PPresCodPep,
                PPresPresupuesto: Utilities.isNullObject(x.PPresPresupuesto) ? x.PPresPresupuesto : { id: x.PPresPresupuesto.Id, label: x.PPresPresupuesto.Title },
                PPresTotalAnio: x.PPresTotalAnio,
                PPresEnero: x.PPresEnero,
                PPresFebrero: x.PPresFebrero,
                PPresMarzo: x.PPresMarzo,
                PPresAbril: x.PPresAbril,
                PPresMayo: x.PPresMayo,
                PPresJunio: x.PPresJunio,
                PPresJulio: x.PPresJulio,
                PPresAgosto: x.PPresAgosto,
                PPresSeptiembre: x.PPresSeptiembre,
                PPresOctubre: x.PPresOctubre,
                PPresNoviembre: x.PPresNoviembre,
                PPresDiciembre: x.PPresDiciembre,
                PPresEsRegion: x.PPresEsRegion,
                OCTAVIAPaisId: x.OCTAVIAPaisId,
                PPresTipoSedeOnId: x.PPresTipoSedeOnId,
                EdicionPepLibre: x.EdicionPepLibre
            }
            return aux;
        });

        //Table FFCC mapping
        let _tableFFCCAux: any = details.filter((x: any) => { if (Utilities.isNullEmptyObject(x.PPresCeco)) { return true; } });
        let tableFFCC: Array<any> = _tableFFCCAux.map((x: any) => {
            let aux = {
                Id: x.Id,
                PPresTotalAnio: x.PPresTotalAnio,
                PPresEnero: x.PPresEnero,
                PPresFebrero: x.PPresFebrero,
                PPresMarzo: x.PPresMarzo,
                PPresAbril: x.PPresAbril,
                PPresMayo: x.PPresMayo,
                PPresJunio: x.PPresJunio,
                PPresJulio: x.PPresJulio,
                PPresAgosto: x.PPresAgosto,
                PPresSeptiembre: x.PPresSeptiembre,
                PPresOctubre: x.PPresOctubre,
                PPresNoviembre: x.PPresNoviembre,
                PPresDiciembre: x.PPresDiciembre,
                EdicionPepLibre: x.EdicionPepLibre,
                PPresDepartamento: Utilities.isNullObject(x.PPresDepartamento) ? x.PPresDepartamento : { id: x.PPresDepartamento.Id, label: x.PPresDepartamento.Title },
                PPresCodSubvencion: Utilities.isNullObject(x.PPresCodSubvencion) ? x.PPresCodSubvencion : { id: x.PPresCodSubvencion.Id, label: x.PPresCodSubvencion.OCTAVIACodigoSubvencion },
                OCTAVIAFinanciadorSap: Utilities.isNullObject(x.OCTAVIAFinanciadorSap) ? x.OCTAVIAFinanciadorSap : { id: x.OCTAVIAFinanciadorSap.Id, label: x.OCTAVIAFinanciadorSap.Title },
                OCTAVIACodigoProyecto: Utilities.isNullObject(x.OCTAVIACodigoProyectoId) ? x.OCTAVIACodigoProyecto : { id: x.OCTAVIACodigoProyecto.ID, label: x.OCTAVIACodigoProyecto.Title },
                PPresPresupuesto: Utilities.isNullObject(x.PPresPresupuesto) ? x.PPresPresupuesto : { id: x.PPresPresupuesto.Id, label: x.PPresPresupuesto.Title },
                PPresNatuGasto: Utilities.isNullObject(x.PPresNatuGasto) ? x.PPresNatuGasto : { id: x.PPresNatuGasto.Id, label: x.PPresNatuGasto.Title },
                ProaRecupCostes: Utilities.isNullObject(x.ProaRecupCostes) ? x.ProaRecupCostes : { id: x.ProaRecupCostes.Id, label: x.ProaRecupCostes.Title },
                PPresCodProyFFCC: x.PPresCodProyFFCC,
                OCTAVIALineaIntervencion: Utilities.isNullObject(x.PPresFinalidad) ?
                    Utilities.isNullObject(x.OCTAVIALineaIntervencion)
                        ? x.OCTAVIALineaIntervencion
                        : { id: x.OCTAVIALineaIntervencion.Id, label: x.OCTAVIALineaIntervencion.Title }
                    : { id: String.Format("{0}{1}", Constants.Globals.PREFFIX_PURPOSES, x.PPresFinalidad.Id), label: x.PPresFinalidad.Title },
            };
            return aux;
        });

        //Table FFRR mapping
        let _tableFFRRAux: any = details.filter((x: any) => { if (!Utilities.isNullEmptyObject(x.PPresCeco)) { return true; } });
        let tableFFRR = _tableFFRRAux.map((x: any) => {
            let aux = {
                Id: x.Id,
                PPresTotalAnio: x.PPresTotalAnio,
                PPresEnero: x.PPresEnero,
                PPresFebrero: x.PPresFebrero,
                PPresMarzo: x.PPresMarzo,
                PPresAbril: x.PPresAbril,
                PPresMayo: x.PPresMayo,
                PPresJunio: x.PPresJunio,
                PPresJulio: x.PPresJulio,
                PPresAgosto: x.PPresAgosto,
                PPresSeptiembre: x.PPresSeptiembre,
                PPresOctubre: x.PPresOctubre,
                PPresNoviembre: x.PPresNoviembre,
                PPresDiciembre: x.PPresDiciembre,
                PPresCampanas: Utilities.isNullObject(x.PPresCampanas) ? x.PPresCampanas : { id: x.PPresCampanas.Id, label: x.PPresCampanas.Title },
                PPresPresupuesto: Utilities.isNullObject(x.PPresPresupuesto) ? x.PPresPresupuesto : { id: x.PPresPresupuesto.Id, label: x.PPresPresupuesto.Title },
                PPresNatuGasto: Utilities.isNullObject(x.PPresNatuGasto) ? x.PPresNatuGasto : { id: x.PPresNatuGasto.Id, label: x.PPresNatuGasto.Title },
                ProaRecupCostes: Utilities.isNullObject(x.ProaRecupCostes) ? x.ProaRecupCostes : { id: x.ProaRecupCostes.Id, label: x.ProaRecupCostes.Title },
                PPresCeco: Utilities.isNullObject(x.PPresCeco) ? x.PPresCeco : { id: x.PPresCeco.Id, label: x.PPresCeco.Title },
                OCTAVIAFinanciadorSap: Utilities.isNullObject(x.OCTAVIAFinanciadorSap) ? x.OCTAVIAFinanciadorSap : { id: x.OCTAVIAFinanciadorSap.Id, label: x.OCTAVIAFinanciadorSap.Title },
                PPresFinalidad: Utilities.isNullObject(x.PPresFinalidad) ?
                    Utilities.isNullObject(x.OCTAVIALineaIntervencion)
                        ? x.OCTAVIALineaIntervencion
                        : { id: x.OCTAVIALineaIntervencion.Id, label: x.OCTAVIALineaIntervencion.Title }
                    : { id: String.Format("{0}{1}", Constants.Globals.PREFFIX_PURPOSES, x.PPresFinalidad.Id), label: x.PPresFinalidad.Title }
            };
            return aux;
        })

        return { tableByProject, tableFFRR, tableFFCC };
    }
    async getProjectNumber(title?: string): Promise<string> {
        const key = title ? title : Enums.ConsecutiveKeys.PresCodigoProyecto;
        let consecutive = await this.getConsecutive(key);
        if (Utilities.isNullEmptyObject(consecutive)) {
            consecutive = await this.setConsecutive(key);
        }
        return Utilities.convertNumToConsecutive(consecutive.PMaxNumLenth, consecutive.PContador + consecutive.PIncremento);
    }
    async getProjectCodeId(projectCode: string, basicData: ICmdBasicDataProjectBudget) {
        let codeItem: any = await this.spListService.getItems({
            listName: Enums.ListTypes.Project,
            filter: String.Format(
                Constants.FiltersFormats.FILTER_BY_TITLE,
                projectCode
            ),
        });
        if(!codeItem || !codeItem.length){
            let item: any = {Title: projectCode, OCTAVIACodigo: projectCode, OCTAVIAActivo: true}
            if(basicData.OCTAVIARegionId) item.OCTAVIARegionId = basicData.OCTAVIARegionId;
            if(basicData.OCTAVIAPaisId) item.OCTAVIAPaisId = basicData.OCTAVIAPaisId;
            codeItem = await this.spListService.addItem({
                listName: Enums.ListTypes.Project,
                item
            });
        }else{
            let item: any = {OCTAVIAActivo: true}
            if(basicData.OCTAVIARegionId) item.OCTAVIARegionId = basicData.OCTAVIARegionId;
            if(basicData.OCTAVIAPaisId) item.OCTAVIAPaisId = basicData.OCTAVIAPaisId;
            await this.spListService.updateItem<any>({
                listName: Enums.ListTypes.Project,
                item,
                itemId: codeItem[0].Id
            });
        }
        return Array.isArray(codeItem) ? codeItem[0].Id : codeItem.Id;
    }
    async getBasicBudgets(filter: boolean) {
        const data: any = {};
        data.listName = Enums.ListTypes.BaseBudget;
        data.columnsToSelect = Constants.Selects.BUDGET_BASIC;
        data.expands = Constants.Expands.BUDGET_BASIC;
        if (filter) {
            data.filter = String.Format(Constants.FiltersFormats.FILTER_BY_PPRESTIPOPRESID, "1")
        }
        const basicBudgets = await this.spListService.getItems(data);
        return basicBudgets;
    }
    async getExpandBudgets() {
        const budget = await this.spListService.getItems({
            listName: Enums.ListTypes.BaseBudget,
            columnsToSelect: Constants.Selects.BUDGET_BASIC,
            expands: Constants.Expands.BUDGET_BASIC
        });
        return budget;
    }
    async getAllBudgetAndDetails() {
        const budgets = await this.spListService.getItems({
            listName: Enums.ListTypes.BaseBudget,
            columnsToSelect: Constants.Selects.BUDGET_BASIC,
            expands: Constants.Expands.BUDGET_BASIC
        });

        const details = await this.spListService.getItems({
            listName: Enums.ListTypes.DetailDataBudget,
            columnsToSelect: Constants.Selects.BUDGET_DETAILS,
            expands: Constants.Expands.BUDGET_DETAILS
        });

        let value = this.getDetailHeader(budgets, details);

        return value;
    }
    async getBudgetAndDetails(budgetId: number) {
        const budget = await this.spListService.getItem<any>({
            listName: Enums.ListTypes.BaseBudget,
            itemId: budgetId,
            columnsToSelect: Constants.Selects.BUDGET_BASIC,
            expands: Constants.Expands.BUDGET_BASIC
        });
        const currentBudget = this.mappBudgetEntityToCurrentBudget(budget);

        const details = await this.spListService.getItems({
            listName: Enums.ListTypes.DetailDataBudget,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budget.Id),
            columnsToSelect: Constants.Selects.BUDGET_DETAILS,
            expands: Constants.Expands.BUDGET_DETAILS
        });

        const { tableByProject, tableFFRR, tableFFCC } = this.mappBudgetDetailsToModels(details);

        return { currentBudget, tableByProject, tableFFRR, tableFFCC };
    }
    async saveBudget(
        basicData: ICmdBasicDataProjectBudget,
        projectExist: boolean,
        tableBudgetByProject?: Array<ICmdTableBudgetByProject>,
        tableBudgetFFCC?: Array<ICmdTableBudgetFFCC>,
        tableBudgetFFRR?: Array<ICmdTableBudgetFFRR>,
        PPresTipoPresId?: number,
        currentUserEmail?: string
    ) {
        const CodeConsecutive = basicData.CodeConsecutive;
        delete basicData.Id;
        delete basicData.CodeConsecutive;

        if(basicData && PPresTipoPresId !== Enums.SystemParameters.BudgetTypeOn) basicData.CodigoProyectoId = await this.getProjectCodeId(basicData.PPresCodProy, basicData);
        delete basicData.PPresCodProy   
        let currentUsu = await this.spWebService.ensureUser(currentUserEmail)

        const result = await this.spListService.addItem({
            listName: Enums.ListTypes.BaseBudget,
            item: basicData
        });
         
        if (basicData.PPresTipoPresId !== 2 && !Utilities.isNullEmptyObject(CodeConsecutive)) {
            var codeProject = (await this.spListService.getItems({
                listName: Enums.ListTypes.consecutive,
                filter: String.Format(Constants.FiltersFormats.FILTER_BY_TITLE, CodeConsecutive)
            }) as any)

            if (!projectExist) {
                codeProject = {
                    ...codeProject,
                    PContador: (codeProject[0].PIncremento + codeProject[0].PContador)
                }
                basicData = {
                    ...basicData,
                    PPresNumProy: Utilities.convertNumToConsecutive(codeProject[0].PMaxNumLenth, (codeProject[0].PIncremento + codeProject[0].PContador)),
                    PPresAnioId: basicData.PPresAnioId
                }
                await this.spListService.updateItem({
                    listName: Enums.ListTypes.consecutive,
                    itemId: codeProject[0].Id,
                    item: { PContador: (codeProject[0].PIncremento + codeProject[0].PContador) }
                })
            }
        }
        

        

        if (!Utilities.isNullObject(tableBudgetByProject)) {
            for (let index = 0; index < tableBudgetByProject.length; index++) {
                const element = tableBudgetByProject[index];
                element.PPresPresupuestoId = result.Id;
                element.OCTAVIALineaIntervencionId = result.OCTAVIALineaIntervencionId;
                element.PProaModifiedById = currentUsu.Id;
                await this.spListService.addItem({
                    listName: Enums.ListTypes.DetailDataBudget,
                    item: element
                });
            }
        }

        if (!Utilities.isNullObject(tableBudgetFFCC)) {
            for (let index = 0; index < tableBudgetFFCC.length; index++) {
                const element = tableBudgetFFCC[index];
                element.PProaModifiedById = currentUsu.Id;
                if (!Utilities.isNullEmptyObject(element)) {
                    element.PPresPresupuestoId = result.Id;
                    await this.spListService.addItem({
                        listName: Enums.ListTypes.DetailDataBudget,
                        item: element
                    });
                }
            }
        }

        if (!Utilities.isNullObject(tableBudgetFFRR)) {
            for (let index = 0; index < tableBudgetFFRR.length; index++) {
                const element = tableBudgetFFRR[index];
                element.PProaModifiedById = currentUsu.Id;
                if (!Utilities.isNullEmptyObject(element)) {
                    element.PPresPresupuestoId = result.Id;
                    await this.spListService.addItem({
                        listName: Enums.ListTypes.DetailDataBudget,
                        item: element
                    });
                }
            }
        }

        return result;
    }

    async updateBudget(
        basicData: ICmdBasicDataProjectBudget,
        tableBudgetByProject: Array<ICmdTableBudgetByProject>,
        tablebudgetFFCC: Array<ICmdTableBudgetFFCC>,
        tableFFRR: Array<ICmdTableBudgetFFRR>, 
        currentUserEmail?: string): Promise<any> {

        const _item = { ...basicData };
        delete _item.Id;
        delete _item.CodeConsecutive;

        if(basicData && tableBudgetByProject) _item.CodigoProyectoId = await this.getProjectCodeId(_item.PPresCodProy, basicData);
        delete _item.PPresCodProy

        let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
        let detailsItemsToAdd = []
        let detailsItemsToUpdate = []
        
        const result = await this.spListService.updateItem<any>({
            listName: Enums.ListTypes.BaseBudget,
            item: _item,
            itemId: basicData.Id
        });

        let detailsItems = await this.spListService.getItems({
            listName: Enums.ListTypes.DetailDataBudget,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, basicData.Id)
        })
        let detailsItemsToDelete = detailsItems;
        
        if (!Utilities.isNullObject(tableBudgetByProject)) {
            
            for (let index = 0; index < tableBudgetByProject.length; index++) {
                const element = tableBudgetByProject[index];
                detailsItemsToDelete = detailsItemsToDelete.filter((x: any) => x.Id !== element.Id)
                element.PPresPresupuestoId = basicData.Id;
                element.PProaModifiedById = currentUsu.Id;
                    let itemExist = detailsItems.find((item: any) => item.Id === element.Id)
                    itemExist ? detailsItemsToUpdate.push(element) : detailsItemsToAdd.push(element);
            }
        }

        if (!Utilities.isNullObject(tablebudgetFFCC)) {
            for (let index = 0; index < tablebudgetFFCC.length; index++) {
                const element = tablebudgetFFCC[index];
                detailsItemsToDelete = detailsItemsToDelete.filter((x: any) => x.Id !== element.Id)
                element.PPresPresupuestoId = basicData.Id;
                element.PProaModifiedById = currentUsu.Id;
                if (!Utilities.isNullEmptyObject(element.OCTAVIAFinanciadorSapId)){
                    let itemExist = detailsItems.find((item: any) => item.Id === element.Id)
                    itemExist ? detailsItemsToUpdate.push(element) : detailsItemsToAdd.push(element);
                }
            }
        }

        if (!Utilities.isNullObject(tableFFRR)) {
            for (let index = 0; index < tableFFRR.length; index++) {
                const element = tableFFRR[index];
                detailsItemsToDelete = detailsItemsToDelete.filter((x: any) => x.Id !== element.Id)
                element.PPresPresupuestoId = basicData.Id;
                element.PProaModifiedById = currentUsu.Id;
                if (!Utilities.isNullEmptyObject(element.OCTAVIAFinanciadorSapId)){
                    let itemExist = detailsItems.find((item: any) => item.Id === element.Id)
                    itemExist ? detailsItemsToUpdate.push(element) : detailsItemsToAdd.push(element);
                }
            }
        }

        if(detailsItemsToAdd.length) await this.spListService.addItemsBatch(Enums.ListTypes.DetailDataBudget, detailsItemsToAdd)
        if(detailsItemsToUpdate.length) await this.spListService.updateItemsBatch(Enums.ListTypes.DetailDataBudget, detailsItemsToUpdate)    

        for (let index = 0; index < detailsItemsToDelete.length; index++) {
            const element: any = detailsItemsToDelete[index];
            await this.spListService.deleteItem({
                listName: Enums.ListTypes.DetailDataBudget,
                itemId: element.Id
            });
        }

        return result;
    }
    async getBudgetBasicDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(langId, Enums.ListTypes.BudgetBasicDataColumn);
    }
    async getBudgetDetailColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(langId, Enums.ListTypes.BudgetDetailDataColumn);
    }
    async getAllFormMasters(langLabel: string): Promise<IBudgetFormBasicDataMasters> {
        const result = await Promise.all([
            this.getRegions(langLabel),
            this.getCountries(langLabel),
            this.getBudgetTypes(langLabel),
            this.getYears(),
            this.getGrantCodes(langLabel),
            this.getStrategicLines(langLabel),
            this.getInterventionLines(langLabel),
            this.getNatureExpenditures(langLabel),
            this.getSAPFinancingEntities(langLabel),
            this.getCECOS(langLabel),
            this.getCampaigns(langLabel),
            this.getPurposes(langLabel),
            this.getDepartments(langLabel),
            this.getFFCCFinancingEntities(langLabel),
            this.getFFRRFinancingEntities(langLabel),
            this.getProjectCode(langLabel),
            this.getSedeOn(langLabel),
            this.getCostRecovery(langLabel)
        ]);

        return {
            regions: result[0],
            countries: result[1],
            budgetTypes: result[2],
            years: result[3],
            grantCodes: this.processGrantCodes(result[4]),
            strategicLines: result[5],
            interventionLines: result[6],
            natureExpenditures: result[7],
            sapFinancingEntities: result[8],
            cecos: result[9],
            campaigns: result[10],
            purposes: result[11],
            departments: result[12],
            ffccFinancingEntities: result[13],
            ffrrFinancingEntities: result[14],
            projects: result[15],
            sedeOn: result[16],
            costRecovery: result[17]
        };

    }
    async getAllBudgetSummary(langLabel: string): Promise<any[]> {
        return await this.spListService.getItems({ listName: Enums.ListTypes.BudgetSummary, filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_SUMMARY_PROA, langLabel) });
    }
    async getAllBudgetByCountry(langLabel: string): Promise<IBudgetCsvByCountry[]> {
        return await this.spListService.getItems<IBudgetCsvByCountry>({ listName: Enums.ListTypes.BudgetByCountry, filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_SUMMARY_PROA, langLabel) });
    }
    async getAllBudgetByOn(langLabel: string): Promise<IBudgetCsvByOn[]> {
        return await this.spListService.getItems<IBudgetCsvByOn>({ listName: Enums.ListTypes.BudgetByOn, filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_SUMMARY_PROA, langLabel) });
    }
    async getBudgetResumeDataColumns(landId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(landId, Enums.ListTypes.BudgetResumeDataColumn);
    }
    async getBudgetCSVDataColumns(landId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(landId, Enums.ListTypes.BudgetCsvDataColumn);
    }
    async getBudgetIndexDataColumns(landId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(landId, Enums.ListTypes.BudgetIndexDataColumn);
    }
    async getFormBudgetTablesColumnDefinition(landId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(landId, Enums.ListTypes.BudgetTableBudgetByProject);
    }
    async getFormBudgetTablesFFCCColumnDefinition(landId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(landId, Enums.ListTypes.BudgetTableBudgetByProject);
    }
    async getProjectByGrantCodeId(grantCodeId: number): Promise<any> {
        let items = await this.spListService.getItems<any>({
            listName: Enums.ListTypes.GrantCode,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_ID, grantCodeId)
        });

        if (items.length === 0) {
            return null;
        }

        return await this.spListService.getItems<any>({
            listName: Enums.ListTypes.Project,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_ID, items[0].OCTAVIACodigoProyectoId)
        });
    }
    processGrantCodes(grantCodes: any): any {
        return grantCodes.map((item: any) => {
            item.Title = item.OCTAVIACodigoSubvencion;
            return item;
        });
    }
}